import { render, staticRenderFns } from "./Despesas2.vue?vue&type=template&id=4c798ea1"
import script from "./Despesas2.vue?vue&type=script&lang=js"
export * from "./Despesas2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports